// The web app's URL vocabulary. Web's router consumes it; the Electron shell validates deep links against it.
export enum WebPaths {
  Home = '/',
  Inbox = '/inbox',
  Upcoming = '/upcoming',
  AllTasks = '/all-tasks',
  Completed = '/completed',
  Goals = '/goals',
  GoalsRoadmap = '/goals/roadmap',
  GoalsCompleted = '/goals/completed',
  GoalsArchived = '/goals/archived',
  GoalsThisYear = '/goals/this-year',
  GoalsNextYear = '/goals/next-year',
  GoalsUnplanned = '/goals/unplanned',
  GoalsCalendar = '/goals-calendar',
  GoalDetail = '/goals/:id',
  GoalDetailProgress = '/goals/:id/progress',
  GoalDetailRoadmap = '/goals/:id/roadmap',
  GoalDetailTasks = '/goals/:id/tasks',
  GoalTemplates = '/goal-plans',
  LifeAreas = '/life-areas',
  LifeAreaDetail = '/life-areas/:id',
  LifeAreaDetailGoals = '/life-areas/:id/goals',
  LifeAreaDetailVision = '/life-areas/:id/vision',
  LifeAreaDetailTasks = '/life-areas/:id/tasks',
  Habits = '/habits',
  HabitsCompleted = '/habits/completed',
  Login = '/login',
  Signup = '/signup',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  CompleteSignup = '/complete-signup',
  VerifyEmail = '/verify-email',
  Insights = '/insights',
  TagDetail = '/tags/:id',
  SmartListDetail = '/smart-lists/:id',
  Search = '/search',
  Trash = '/trash',
  TaskCreate = '/tasks/create',
  DesktopConnected = '/desktop-connected',
}
